import { Controller } from "@hotwired/stimulus"
import Collapse from "flowbite/lib/esm/components/collapse"

const STORAGE_KEY = "events-filter-panel-open"

export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.collapse = new Collapse(this.panelTarget, this.triggerTarget)

    if (sessionStorage.getItem(STORAGE_KEY) === "true") {
      this.triggerTarget.checked = true
      this.collapse.expand()
    }
  }

  disconnect() {
    if (this.collapse) {
      this.collapse.destroy()
      this.collapse = null
    }
  }

  persist() {
    sessionStorage.setItem(STORAGE_KEY, this.triggerTarget.checked)
  }
}
